import api from '../index'

const api_requests = {
    create: async (file, isbase64, name) => {
        try {
            var response = null
            if (typeof file === 'string') {
                if (isbase64 == null) {
                    throw 'When create a resource from a string, please provide the isbase64 (bool) argument'
                }
                var payload = {
                    filename: name,
                    content: file,
                    base64Encoded: isbase64
                }
                response = await api.post('/resource/Resources/fromstring', payload)
                response.data.src = file
                response.data.file = null
            } else {
                var formData = new FormData()
                formData.append('file', file)
                var prom = api.post('/resource/Resources', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                if (file.type == 'image/heic') {
                    response = await prom
                } else {
                    var base64 = await file.toBase64()
                    response = await prom
                    response.data.src = base64
                }
                response.data.file = file
            }
            return response.data
        } catch (error) {
            if (error.response) {
                throw error.response.status
            } else throw error
        }
    },
    getUrl: (uuid) => {
        return `${api.defaults.baseURL}/resource/Resources/${uuid}`
    },
    get: (uuid) => {
        return {
            id: uuid,
            src: `${api.defaults.baseURL}/resource/Resources/${uuid}`
        }
    },
    download: async (resource) => {
        try {
            var response = await api.get(`/resource/Resources/${resource.id}/file`, {
                responseType: 'blob'
            })

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', resource.filename) //or any other extension
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        } catch (error) {
            if (error.response) {
                throw error.response.status
            } else throw error
        }
    },
    getMeta: async (uuid) => {
        try {
            var response = await api.get(`/resource/Resources/${uuid}/meta`)
            return response.data
        } catch (error) {
            if (error.response) {
                throw error.response.status
            } else throw error
        }
    },
    delete: async (uuid) => {
        try {
            var response = await api.delete(`/resource/Resources/${uuid}`)
            return response.data
        } catch (error) {
            if (error.response) {
                if (error.response.status != 404) {
                    throw error.response.status
                }
            } else throw error
        }
    }
}

export default api_requests
